module.exports = __webpack_public_path__ + "img/frame_background.4ffe576f.svg";